import React from "react";
import Button from '@mui/material/Button';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import useAddBedHook from "./addBedHooks";
import useWardTableHook from "../ward/wardFetchHook";
import useRoomTypeTableHook from "../roomType/roomTypeTableHook";

const initialState = {
    activeStatus: false,
    wardID: "",
    roomTypeID: "",
    description: "",
    roomTypeID: "",
    bedStatus: "",
}
const AddBed = () => {
    const {
        bedState,
        allowNumbersOnly,
        handleInputChange,
        handleBedSubmit,
        handleGoBack
    } = useAddBedHook(initialState);
    const {  wardState } = useWardTableHook();
    const { roomTypeState } = useRoomTypeTableHook()
    return (
        <>

            <form>
                <div className="basic-info" >
                    <div className="mt-2 ml-4">
                        <h4>Add Bed</h4>
                        <div className="back-btn"
                            onClick={handleGoBack}
                        >
                            <ArrowBackIcon className="arrow-color" />
                            <span
                                style={{ cursor: "pointer" }}
                                className="anchr-link header-text mt-3 mb-3"
                            >
                                {"Back"}
                            </span>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="form-group col-md-6">
                            <label for="fname" className="control-label col-sm">Bed Number*</label>
                            <div class="col-auto">
                                <div class="input-group mb-2">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text"><AccountBalanceIcon /></div>
                                    </div>
                                    <input type="text"
                                        className="form-control"
                                        id="exampleInputEmail1" aria-describedby="emailHelp"
                                        placeholder="Bed Number" name="bedNumber"
                                        value={bedState?.bedNumber}
                                        onChange={handleInputChange} required
                                        onKeyDown={(e) => allowNumbersOnly(e)}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="form-group col-md-6">
                            <label for="lname" className="control-label col-sm">Ward*</label>
                            <div class="col-auto">
                                <div class="input-group mb-2">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text"><i class="fas fa-code-branch"></i></div>
                                    </div>
                                    <select
                                        className={"form-control"}
                                        selected={bedState?.wardID}
                                        value={bedState?.wardID}
                                        onChange={handleInputChange}
                                        required
                                        name="wardID"
                                    >
                                        <option></option>
                                        {
                                            wardState && wardState?.map((ele) => (
                                                <option value={ele.uniqueId}>{ele.wardName}</option>
                                            ))
                                        }
                                       
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div className="form-group col-md-6">
                            <label for="lname" className="control-label col-sm">Room Type*</label>
                            <div class="col-auto">
                                <div class="input-group mb-2">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text"><i class="fas fa-code-branch"></i></div>
                                    </div>
                                    <select
                                        className={"form-control"}
                                        selected={bedState?.roomTypeID}
                                        value={bedState?.roomTypeID}
                                        onChange={handleInputChange}
                                        required
                                        name="roomTypeID"
                                    >
                                        <option></option>
                                        {
                                            roomTypeState && roomTypeState?.map((ele) => (
                                                <option value={ele?.uniqueId}>{ele?.roomTypeName}</option>
                                            ))
                                        }
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div className="form-group col-md-6">
                            <label for="lname" className="control-label col-sm">Bed Status*</label>
                            <div class="col-auto">
                                <div class="input-group mb-2">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text"><i class="fas fa-code-branch"></i></div>
                                    </div>
                                    <input type="text"
                                        className="form-control"
                                        id="exampleInputEmail1" aria-describedby="emailHelp"
                                        placeholder="Bed Status" name="bedStatus"
                                        value={bedState?.bedStatus}
                                        onChange={handleInputChange} required
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="form-group col-md-6">
                            <label for="lname" className="control-label col-sm">Description</label>
                            <div class="col-auto">
                                <div class="input-group mb-2">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text"><i class="fas fa-code-branch"></i></div>
                                    </div>
                                    <textarea
                                        id="exampleInputEmail1" aria-describedby="emailHelp"
                                        type="text" className="form-control"
                                        placeholder="Description" name='description'
                                        value={bedState?.description}
                                        onChange={handleInputChange}
                                    />
                                </div>
                            </div>
                        </div>



                    </div>
                </div>
                <div className="d-flex justify-content-end mr-3 mb-3">
                    <Button variant="outlined" className="mr-2"
                        onClick={(event) => {
                            handleBedSubmit(event)
                        }}
                    >Add Bed</Button>
                </div>
            </form>
        </>
    )
};

export default AddBed;